import { render, staticRenderFns } from "./ExpensesReportComponent.vue?vue&type=template&id=ed6d56fa&scoped=true&"
import script from "./ExpensesReportComponent.vue?vue&type=script&lang=js&"
export * from "./ExpensesReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesReportComponent.vue?vue&type=style&index=0&id=ed6d56fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d56fa",
  null
  
)

export default component.exports